// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;

let signInType;
let username = "";

// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
const myMSALObj = new msal.PublicClientApplication(msalConfig);

// Redirect: once login is successful and redirects with tokens, call Graph API
myMSALObj.handleRedirectPromise().then(handleResponse).catch(err => {
    console.error(err);
});

function handleResponse(resp) {
    // console.log("in handleResponse non-signin start")
    // console.log("resp ",JSON.stringify(resp));

    if (resp !== null) {
        //showWelcomeMessage(resp.account);
        username = resp.account.username;
    } else {
        // need to call getAccount here?
        const currentAccounts = myMSALObj.getAllAccounts();
        // console.log("currentAccounts ",currentAccounts)
        if (currentAccounts === null) {
            return;
        } else if (currentAccounts.length > 1) {
            // Add choose account code here
            let foundItem = currentAccounts.find((item)=>{
                return item.tenantId == tenantId;
            });
            username = foundItem.username;
        } else if (currentAccounts.length === 1) {
            //showWelcomeMessage(currentAccounts[0]);
            username = currentAccounts[0].username;
        }
    }
    // console.log("calling validateOrRefreshToken() from handleResponse method");
    validateOrRefreshToken();
}

async function signIn(method) {
    // console.log("in signIn method")
    signInType = isIE ? "loginRedirect" : method;
    if (signInType === "loginPopup") {
        // console.log("signInType signing in")
        try{
            let resp = await myMSALObj.loginPopup(loginRequest);
            handleResponse(resp);
            return resp;
        }
        catch(error){
            throw error;
        }
    } else if (signInType === "loginRedirect") {
         myMSALObj.loginRedirect(loginRequest)
    }
}

function signOut() {
    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username)
    };
    myMSALObj.logout(logoutRequest);
}

async function getTokenPopup(request, account) {
    // console.log("in getTokenPopup start")
    if(account){
        request.account = account;
    }
    return await myMSALObj.acquireTokenSilent(request).catch(async (error) => {
        // console.log("silent token acquisition fails.");
        if (error instanceof msal.InteractionRequiredAuthError) {
            // console.log("acquiring token using popup");
            return myMSALObj.acquireTokenPopup(request).catch(error => {
                console.error(error);
            });
        } else {
            console.error(error);
        }
    });
}

// This function can be removed if you do not need to support IE
async function getTokenRedirect(request, account) {
    request.account = account;
    return await myMSALObj.acquireTokenSilent(request).catch(async (error) => {
        // console.log("silent token acquisition fails.");
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            // console.log("acquiring token using redirect");
            myMSALObj.acquireTokenRedirect(request);
        } else {
            console.error(error);
        }
    });
}

